export default "__VITE_ASSET__1284cc8a__"